import React from 'react'
import { View, Image, ImageStyle, StyleProp } from 'react-native'

import logo from '@web/assets/images/logoMain.png'
import logoExt from '@web/assets/images/logoExt.png'

type Props = {
  width?: number
  height?: number
  style?: StyleProp<ImageStyle>
}

const ZKXLogo: React.FC<Props> = ({ width = 44, height, style }) => {
  // Maintain 44/49 aspect ratio
  const aspectRatio = 44 / 49
  const calculatedHeight = height ?? width / aspectRatio

  return (
    <View>
      <Image
        source={{ uri: logo }}
        style={[
          {
            width,
            height: calculatedHeight
          },
          style
        ]}
        resizeMode="contain"
      />
    </View>
  )
}

const ZKXLogoExt: React.FC<Props> = ({ width, height, style }) => {
  const aspectRatio = 1 / 1
  const calculatedHeight = height ?? (width ? width / aspectRatio : 0)
  return (
    <View>
      <Image
        source={{ uri: logoExt }}
        style={[
          {
            width,
            height: calculatedHeight
          },
          style
        ]}
        resizeMode="contain"
      />
    </View>
  )
}

export default React.memo(ZKXLogo)
export { ZKXLogoExt }
